import { SECTION_ITEM_TYPE } from "@constants";
import { markLessonCompletedAction } from "@redux/modules/course/slices";
import clsx from "clsx";
import ReactHtmlParser from "react-html-parser";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
// import PropTypes from "prop-types";
import { Button, Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import screenfull from "screenfull";
import styles from "./styles/Assignment.module.css";

export const filterRepeatFile = (assignments) => {
  const result = [];
  for (let i = 0; i < assignments.length; i++) {
    let isExists = false;
    for (let j = 0; j < result.length; j++) {
      if (assignments[i].fileUrl === result[j].fileUrl) {
        isExists = true;
        break;
      }
    }
    if (isExists === false) {
      result.push(assignments[i]);
    }
  }
  return result;
};

const Assignment = (props) => {
  // props
  const { data, hasNext, handleNext } = props;

  // state

  // variables
  const assignmentRef = useRef();
  const dispatch = useDispatch();
  const TIME_READING = 5000;

  // logics before hooks

  // hooks

  // logics

  const toggleFullScreen = () => {
    screenfull.toggle(assignmentRef.current);
  };

  // UI partials
  const buttonFullScreen = (
    <button onClick={toggleFullScreen} className={styles.btnFullScreen}>
      {screenfull.isFullscreen ? (
        <i className="bi bi-arrows-angle-contract"></i>
      ) : (
        <i className="bi bi-arrows-angle-expand"></i>
      )}
    </button>
  );

  const attachmentList = (_attachments) => {
    if (!_attachments || _attachments.length === 0) return null;
    const attachments = filterRepeatFile(_attachments);
    return (
      <div className={styles.attachmentWrapper}>
        <p>Resources for this lecture</p>
        {attachments.map(
          (attachment, index) =>
            attachment.fileUrl && (
              <a
                key={`${attachment.id}-${attachment.assignmentId}`}
                href={attachment.fileUrl}
                target="_blank"
                rel="noreferrer"
                className={styles.attachmentLink}
              >
                <i className="bi bi-file-earmark-arrow-down mr-2"></i>
                {attachment.name ? attachment.name : `Resource ${index + 1}`}
              </a>
            )
        )}
      </div>
    );
  };

  // effects
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!data.isCompleted) {
        dispatch(
          markLessonCompletedAction({
            id: data.id,
            type: SECTION_ITEM_TYPE.ASSIGNMENT,
          })
        );
      }
    }, TIME_READING);
    return () => {
      clearTimeout(timer);
    };
  }, [data.id]);

  // render
  return (
    <div className={styles.container} ref={assignmentRef}>
      <Container className={clsx("px-5 pt-4", styles.mainContent)} fluid>
        <h2>{data.title}</h2>
        <p>{data.description}</p>
        <div>{ReactHtmlParser(data.content?.trim())}</div>

        {attachmentList(data?.attachments)}
      </Container>

      {
        <div className={clsx("px-5", styles.fullscreenWrapper)}>
          {hasNext && <Button onClick={handleNext}>Next lesson</Button>}
          {buttonFullScreen}
        </div>
      }
    </div>
  );
};

/* required: display name */
Assignment.displayName = "Assignment";

/* required: props types */
Assignment.propTypes = {};

/* required: default props */
Assignment.defaultProps = {};

export { Assignment };
